import { Kartutsnitt } from '@/domain/kart/Kartutsnitt';
import { MapLayerType } from '@/components/map/map-utils/WebMapTileServices';
import {
    ActionType,
    AddPointAction,
    GetState,
    MapMovedAction,
    RemovePointAction,
    SetMapLayerAction,
    SetZoomAndCenterAction,
    ZoomToExtentAction,
} from './actiontypes';
import { stateVegnett } from '@/selectors/selectors';
import {
    abortActiveVegobjekterRequests,
    executeAllSearches,
} from '@/middleware/fetchVegobjekter';
import { abortActiveVegnettRequest, fetchVegnett } from '@/middleware/fetchVegnett';
import { MapPoint } from '@/domain/kart/MapPoint';
import { apiUpdateAction } from '@/actions/metaActions';
import type { Dispatch } from '@/state/store';
import { notifyMapNavigationStarted } from '@/utils/mapNavigationEvents';

export type mapMovedT = (
    center: [number, number],
    zoom: number,
    kartutsnitt: Kartutsnitt
) => (dispatch: Dispatch, getState: GetState) => void;
export const mapMoved: mapMovedT =
    (center: [number, number], zoom: number, kartutsnitt: Kartutsnitt) =>
    (dispatch: Dispatch, getState: GetState) => {
        const vegnettState = stateVegnett(getState());
        const mapMovedAction: MapMovedAction = {
            type: ActionType.MAP_MOVED,
            center,
            zoom,
            kartutsnitt,
        };

        dispatch(apiUpdateAction());
        dispatch(mapMovedAction);
        dispatch(executeAllSearches());
        if (vegnettState.visible) {
            dispatch(fetchVegnett());
        }
    };

export type mapNavigationStartedT = () => (dispatch: Dispatch) => void;
export const mapNavigationStarted: mapNavigationStartedT = () => (dispatch: Dispatch) => {
    abortActiveVegobjekterRequests();
    abortActiveVegnettRequest();
    notifyMapNavigationStarted();
    dispatch(apiUpdateAction());
};

export type setZoomAndCenterT = (
    center: [number, number],
    zoom: number
) => (dispatch: Dispatch) => void;
export const setZoomAndCenter: setZoomAndCenterT =
    (center: [number, number], zoom: number) => (dispatch: Dispatch) => {
        const setZoomAndCenterAction: SetZoomAndCenterAction = {
            type: ActionType.MAP_CENTER_AND_ZOOM_SET,
            center,
            zoom,
        };
        dispatch(setZoomAndCenterAction);
    };

export type zoomToExtentT = (extent: Kartutsnitt | null) => (dispatch: Dispatch) => void;
export const zoomToExtent: zoomToExtentT =
    (kartutsnitt: Kartutsnitt | null) => (dispatch: Dispatch) => {
        const zoomAction: ZoomToExtentAction = {
            type: ActionType.MAP_EXTENT_ZOOMED_TO,
            kartutsnitt,
        };
        dispatch(zoomAction);
    };

export type setMapLayerT = (
    maplayer: MapLayerType
) => (dispatch: Dispatch, getState: GetState) => void;
export const setMapLayer: setMapLayerT =
    (maplayer: MapLayerType) => (dispatch: Dispatch) => {
        const setMapLayerAction: SetMapLayerAction = {
            type: ActionType.MAP_LAYER_SET,
            maplayer,
        };
        dispatch(setMapLayerAction);
    };

export type removePointFromMapT = (
    id: string
) => (dispatch: Dispatch, getState: GetState) => void;
export const removePointFromMap = (id: string) => (dispatch: Dispatch) => {
    const action: RemovePointAction = {
        type: ActionType.MAP_POINT_REMOVED,
        id,
    };
    dispatch(action);
};
export type addPointToMapT = (
    point: MapPoint
) => (dispatch: Dispatch, getState: GetState) => void;
export const addPointToMap = (point: MapPoint) => (dispatch: Dispatch) => {
    const action: AddPointAction = {
        type: ActionType.MAP_POINT_ADDED,
        point,
    };
    dispatch(action);
};
